import {Alert} from 'src/design/atoms/Alert';
import {List} from 'src/design/atoms/List';
import {Text} from 'src/design/atoms/Text';
import React from 'react';

import type {
  CourseDefinitionQuizQuestionAnswerResponse,
  CourseSessionQuizQuestionAnswerResponse,
} from 'src/api/ProactApiClient';

export interface SessionAnswerShowCorrectAnswerProps {
  answers: CourseDefinitionQuizQuestionAnswerResponse[];
  sessionAnswers: CourseSessionQuizQuestionAnswerResponse[];
  isQuestionCorrect?: boolean;
  showCorrectResult?: boolean;
  pronoun?: 'You' | 'The trainee';
}
export const SessionAnswerShowCorrectAnswer: React.FC<
  SessionAnswerShowCorrectAnswerProps
> = ({
  answers,
  sessionAnswers,
  isQuestionCorrect,
  showCorrectResult,
  pronoun = 'You',
}) => {
  function getActualAnswerText() {
    const selectedAnswers = sessionAnswers.filter(x => x.isSelected === true);
    const selectedIds = selectedAnswers.map(i => i.answerDefinitionId!);

    if (selectedIds.length > 0) {
      const answerDs = answers.filter(x => selectedIds.includes(x.id!));
      return answerDs;
    }
    return [];
  }

  function getCorrectAnswerText() {
    const selectedAnswers = sessionAnswers.filter(
      x =>
        (x.isCorrect === false && x.isSelected === false) ||
        (x.isCorrect === true && x.isSelected === true)
    );
    const selectedIds = selectedAnswers.map(i => i.answerDefinitionId!);

    if (selectedIds.length > 0) {
      const answerDs = answers.filter(x => selectedIds.includes(x.id!));
      return answerDs;
    }
    return [];
  }

  const actualAnswers = getActualAnswerText();
  const correctAnswers = getCorrectAnswerText();

  return showCorrectResult && !isQuestionCorrect ? (
    <Alert title="Correct Answer" color="yellow" mt="md" mb="md">
      <Text>{pronoun} answered:</Text>
      <List withPadding mb="md">
        {actualAnswers.map(a => (
          <List.Item>{a.text}</List.Item>
        ))}
      </List>
      <Text>The correct answers are:</Text>
      <List withPadding>
        {correctAnswers.map(a => (
          <List.Item>{a.text}</List.Item>
        ))}
      </List>
    </Alert>
  ) : (
    <></>
  );
};
